import styled from "styled-components";

export const ChatbotMessagesDisplay = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  .chatbot-container {
    padding: 20px 14px 0px 29px;
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: scroll;
    &__empty {
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    &__empty-container {
      width: 180px;
      position: relative;
      display: flex;
      justify-content: center;
      &__shadow {
        z-index: 1;
        display: flex;
        /* width: 10px; */
        /* height: 10px; */
        position: absolute;
        align-self: center;
        box-shadow: 0px 3.03px 121.47px 60px #3e76fa66;
      }
    }
    &__empty-image {
      width: 180px;
      height: 100%;
      z-index: 2;
    }
    &__empty-msg {
      margin-top: 20px;
      font-size: 17px;
      color: #707582;
    }
  }
  .chatbot-footer {
    padding: 20px;
  }

  .file-selected {
    flex: 1;
    background-color: #f0f0ff;
    justify-content: center;
    justify-items: center;
    .header {
      display: flex;
      justify-content: space-between;
      padding: 20px;
      width: 100%;
      box-sizing: border-box;
      &__close {
        background-color: #3e3da3;
        width: 40px;
        height: 40px;
        border-radius: 27.5px;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        font-size: 14px;
      }
      &__info {
        display: flex;
      }
      &__img {
        margin-right: 10px;
      }
      &__text {
        color: #68688d;
        align-items: center;
      }
    }
  }
  .files {
    overflow: auto;
    place-items: center;
  }
  .file {
    height: 250px;
    width: 300px;
    border-radius: 14px;
    overflow: hidden;
    margin-bottom: 10px;
    position: relative;
    .file__preview {
      width: 100%;
      height: 100%;
      background-color: #fff;
      color: #707582;
      display: flex;
    }
    .file__icon {
      margin: auto;
      font-size: 172px;
    }
    .file__img {
      width: 100%;
      height: 100%;
      border: 2px solid #ffffff7d;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .file__title {
      width: 100%;
      padding: 16px 10px;
      color: #1f1f52;
      font-size: 12px;
      background-color: #f2f2f794;
      position: absolute;
      bottom: 0;
    }
  }
`;
